import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

import { computed, useSlots } from "vue";
import { IconVariant } from "@/types";
import { onboardingStore } from "@/hooks";
import { Icon, TextButton, Typography } from "@/components";


/**
 * A substep in the onboarding process that displays a callout message.
 */
const __default__ = {
  name: "CalloutSubStep",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    icon: {},
    message: {},
    status: {}
  },
  setup(__props: any) {

const props = __props;

const slots = useSlots();

const iconVariant = computed(() => {
  if (props.icon) {
    return props.icon;
  } else if (props.status === "error") {
    return "error";
  } else if (props.status === "success") {
    return "success";
  } else {
    return "info";
  }
});

const color = computed(() => {
  if (props.status === "error") {
    return "negative";
  } else if (props.status === "success") {
    return "primary";
  } else {
    return "secondary";
  }
});

const className = computed(() => `bd-${color.value} q-mt-md`);

return (_ctx: any,_cache: any) => {
  const _component_q_banner = _resolveComponent("q-banner")!

  return (_openBlock(), _createBlock(_component_q_banner, {
    rounded: "",
    class: _normalizeClass(className.value)
  }, {
    avatar: _withCtx(() => [
      _createVNode(_unref(Icon), {
        variant: iconVariant.value,
        color: color.value,
        size: "md"
      }, null, 8, ["variant", "color"])
    ]),
    action: _withCtx(() => [
      _renderSlot(_ctx.$slots, "action"),
      (!_unref(slots).action)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            color: color.value,
            icon: "calendar",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onboardingStore).handleScheduleCall(props.status === 'error')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Schedule a Call ")
            ]),
            _: 1
          }, 8, ["color"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Typography), {
        value: props.message
      }, null, 8, ["value"])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})